var path = 'app/sections/widgets/editor/common/widgetEditorButton.html';
var html = "<span\n  ng-style=\"{'font-size': $ctrl.getFontScaleStyle($ctrl.fontScale)}\"\n  as-sortable-item-handle\n>\n  {{$ctrl.text}}\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;